













































































































































































































































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import {
  Customer,
  User,
  ApiError,
  Vehicle,
  Booking,
  ConfirmationEmailRequest,
} from '@/api';
import { snackModule, authModule, bookingModule } from '@/store';
import AbstractTable from '@/components/admin/AbstractTable.vue';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import VehicleModalEdit from '@/components/admin/VehicleModalEdit.vue';
import ManageSubscription from '../frontend/ManageSubscription.vue';

@Component({
  components: {
    AbstractTable,
    ConfirmDialog,
    VehicleModalEdit,
    ManageSubscription,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;
  loading: boolean = false;
  tabs: number = 0;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  passwordChars: any[] = [
    {
      name: 'Lowercase',
      value: 'abcdefghjklmnpqrstuvwxyz',
    },
    {
      name: 'Uppercase',
      value: 'ABCDEFGHJKLMNPQRSTUVWXYZ',
    },
    {
      name: 'Numbers',
      value: '23456789',
    },
    {
      name: 'Special Characters',
      value: '_-+=)(*&^%$#@!`~',
    },
  ];
  passwordLength: number = 16;
  showPassword: boolean = false;

  customer: Customer | null = null;
  user: User | null = null;
  newUser: boolean = false;

  backConfirmDialog: boolean = false;

  selectedVehicles: Vehicle[] = [];
  vehicleConfirmDialog: boolean = false;
  vehicleAddEdit: boolean = false;
  vehicleToEdit: Vehicle | null = null;

  selectedBookings: Booking[] = [];
  bookingConfirmDialog: boolean = false;
  bookingToEdit: Booking | null = null;

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  requiredArray = [
    (v: string) =>
      v8n()
        .array()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  emailRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'Email address required',

    (v: string) =>
      v8n()
        .pattern(/\S+@\S+\.\S+/)
        .test(v) || 'Email address must be valid',
  ];

  passwordRules = [
    (v: string) =>
      v8n()
        .optional(
          v8n()
            .string()
            .minLength(8),
          true,
        )
        .test(v) || 'Password must be at least 8 chars',
    (v: string) =>
      v8n()
        .optional(
          v8n()
            .not.numeric()
            .minLength(8),
          true,
        )
        .test(v) || 'Password must include non-numeric chars',
  ];

  get windowSize() {
    return window.outerWidth;
  }

  get customerId() {
    return this.$route.params.customerId;
  }

  get userId() {
    if (!this.customer || !this.customer.user) {
      return;
    }
    return this.customer.user.id;
  }

  get currentUser() {
    if (!authModule.user) {
      return null;
    }

    return authModule.user.id;
  }

  get titles() {
    if (!bookingModule.titles) {
      return;
    }
    return bookingModule.titles;
  }

  get roles() {
    if (!authModule.roles) {
      return;
    }
    return authModule.roles;
  }

  get vehicleHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Rego',
        value: 'rego',
        width: 100,
      },
      {
        text: 'Make',
        value: 'make',
      },
      {
        text: 'Model',
        value: 'model',
      },
      {
        text: 'Type',
        value: 'vehicleType.name',
      },
      {
        text: 'Colour',
        value: 'colour',
      },
    ];
  }

  get vehicleScope() {
    return () =>
      Vehicle.includes(['vehicleType']).where({
        owner: this.customerId,
        deleted: false,
        regoUuid: false,
      });
  }

  get selectedVehicle() {
    return this.selectedVehicles[0] || null;
  }

  get bookingHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Booking Type',
        value: 'bookingType',
      },
      {
        text: 'Vehicle',
        value: 'rego',
      },
      {
        text: 'Departure',
        value: 'startDatetime',
      },
      {
        text: 'Arrival',
        value: 'endDatetime',
      },
      {
        text: 'Total Cost',
        value: 'totalCost',
      },
      {
        text: 'Status',
        value: 'status',
        width: 80,
        align: 'center',
        sortable: false,
      },
    ];
  }

  get bookingScope() {
    return () => Booking.includes([]).where({ customer: this.customerId });
  }

  get bookingDefaultOptions() {
    return Booking.defaultOptions();
  }

  get selectedBooking() {
    return this.selectedBookings[0] || null;
  }

  vehicleClicked(item: Vehicle) {
    if (!item) {
      return;
    }

    this.vehicleToEdit = item;
    this.vehicleAddEdit = true;
  }

  addVehicle(edit: boolean = false) {
    if (edit) {
      this.vehicleToEdit = this.selectedVehicle;
    } else {
      this.vehicleToEdit = null;
    }

    this.vehicleAddEdit = true;
  }

  confirmDeleteVehicle() {
    this.vehicleConfirmDialog = true;
  }

  vehicleSaved() {
    this.vehicleAddEdit = false;
    snackModule.showSnackbar('Vehicle Saved');
    this.updateVehicles();
  }

  vehicleClosed() {
    this.vehicleAddEdit = false;
  }

  updateVehicles() {
    (this.$refs.vehicleTable as AbstractTable).update();
  }

  bookingClicked(item: Booking) {
    if (!item) {
      return;
    }

    this.addBooking(true, item);
  }

  addBooking(edit: boolean = false, booking: Booking = this.selectedBooking) {
    if (edit) {
      if (!booking.id) {
        return;
      }
      this.$router.push({
        name: 'admin-bookings-edit',
        params: { bookingId: booking.id },
      });
    } else {
      if (!this.customerId) {
        return;
      }
      this.$router.push({
        name: 'admin-bookings-add',
        query: { customer: this.customerId },
      });
    }
  }

  confirmDeleteBooking() {
    this.bookingConfirmDialog = true;
  }

  updateBookings() {
    (this.$refs.bookingTable as AbstractTable).update();
  }

  createUser() {
    if (!this.customer) {
      return;
    }
    this.newUser = true;
    this.user = new User();
    this.user.roles = ['Customers'];//
  }

  generatePassword() {
    if (!this.customer || !this.user) {
      return;
    }

    let result = '';
    let charactersVal = '';

    for (const chars of this.passwordChars) {
      charactersVal += chars.value;
    }

    for (let i = 0; i < this.passwordLength; i++) {
      result += charactersVal.charAt(
        Math.floor(Math.random() * charactersVal.length),
      );
    }

    this.user.password = result;
  }

  confirmBack() {
    if (this.customer && this.customer.isDirty()) {
      this.backConfirmDialog = true;
    } else {
      this.back();
    }
  }

  back() {
    this.$router.back();
  }

  async deleteSelectedVehicle() {
    if (!this.selectedVehicle) {
      return;
    }

    try {
      this.selectedVehicle.deleted = true;
      await this.selectedVehicle.save();
    } catch (err) {
      // Error
    } finally {
      this.vehicleConfirmDialog = false;
      this.selectedVehicles = [];
      this.updateVehicles();
    }
  }

  async deleteSelectedBooking() {
    if (!this.selectedBooking) {
      return;
    }

    try {
      await this.selectedBooking.destroy();
    } catch (err) {
      // Error
    } finally {
      this.bookingConfirmDialog = false;
      this.selectedBookings = [];
      this.updateBookings();
    }
  }

  async resendConfirm() {
    if (!this.customer) {
      return;
    }
    try {
      const confirmEmail = new ConfirmationEmailRequest({
        email: this.customer.email,
      });
      await confirmEmail.save();
      snackModule.showSnackbar('Confirmation email sent.');
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async save() {
    if (!this.customer) {
      return;
    }

    try {
      if (this.newUser && this.user) {
        this.user.email = this.customer.email;
        this.user.title = this.customer.title;
        this.user.firstName = this.customer.firstName;
        this.user.lastName = this.customer.lastName;
        this.user.phoneNumber = this.customer.phoneNumber;
        this.user.business = this.customer.business;
        await this.user.save();
        this.customer.id = this.user.customer.id;
        this.customer.user = this.user;
        this.newUser = false;
      } else {
        if (this.user) {
          await this.user.save();
        }
        await this.customer.save();
      }

      if (
        this.$route.name === 'admin-customers-add' &&
        this.customer &&
        this.customer.id
      ) {
        this.$router.push({
          name: 'admin-customers-edit',
          params: { customerId: this.customer.id },
        });
        snackModule.showSnackbar('Customer Created');
      } else {
        snackModule.showSnackbar('Customer Updated');
      }
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    if (this.$route.name === 'admin-customers-edit' && this.customerId) {
      try {
        this.loading = true;
        this.customer = (
          await Customer.includes(['user']).find(this.customerId)
        ).data;
        if (this.userId) {
          this.user = (await User.find(this.userId)).data;
        }
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Customer not found');
      } finally {
        this.loading = false;
      }
    } else {
      this.customer = new Customer();
    }
  }
}
